import * as paper from 'paper';
import {Point, Path, Size, PointText} from "paper";
import {DrawDisplayData} from "../drawDisplayData";
import {DisplayFunctions} from "./displayFunctions";
import {DrawData} from "../drawData";

export class CountertopDrawFunction {
    bDrawing = false;       // True : Now drawing path

    rectDirection = 0;  // Drawing Direction.   0 : Vertical,     1 : Horizontal
    leftToRight = 1;    // Horizontal Direction.    1 : Left To Right,  -1 : Right To Left
    topToBottom = 1;    // Vertical Direction.      1 : Top To Bottom,  -1 : Bottom To Top

    drawPath: any;               // Temp path
    startPoint: any;         // The start point when the mouse was downed or mouse direction was changed.
    actualStartPoint: any;    // The start point of cursor if startPoint was adjusted via code to respect buffer
    dashedItems: any;        // The temporary variable to store rectangles in drawing.

    drawed = false;     // If true, redraw. If false, draw. 

    //  It is needed when make completed path
    drawSegments: any[] = [];
    extSegments: any[] = [];
    lastSegments: any[] = [];
    angleSegments: any[] = [];
    completedPath: any;      // The variable to store completed path.

    firstDrag = 0;      // It presents whether first rectangle was drawed or not

    edgeInvalidObjs: any[] = [];
    isEdgeInvalid = false;

    tool: paper.Tool;
    hud: paper.PointText = new PointText({
        point: new Point(0, 0),
        style: {
            fontWeight: 'bold',
            fontSize: 14
        },
        visible: false,
        opacity: 0.6
    });

    constructor(tool: paper.Tool) {
        this.tool = tool;
    }

    startDraw(actualStartPoint: any, startPoint: any) {
        this.bDrawing = true;
        this.dashedItems = [];
        this.drawSegments = [];
        this.extSegments = [];
        this.lastSegments = [];
        this.angleSegments = [];
        this.actualStartPoint = actualStartPoint;
        this.startPoint = startPoint;
        this.firstDrag = 0;
        this.tool.minDistance = 20;
        //show hud
        this.updateHUD(0, this.startPoint.x, this.startPoint.y);
        this.hud.visible = true;
    }

    //loops through all segments to find if any segments need to be brought inside buffer
    //if one is found, they all have to be adjusted by the y or x change
    adjustSegmentsForBuffer() {
        var yAdjustment: number = 0;
        var xAdjustment: number = 0;
        var yBottomAdjustment: number = 0;
        var xRightAdjustment: number = 0;
        var i: number;
        var tempXAdjustment: number;
        var tempYAdjustment: number;

        for (i = 0; i < this.drawSegments.length; i++) {
            if (this.drawSegments[i].x < DrawDisplayData.LEFT_BUFFER) {
                tempXAdjustment = DrawDisplayData.LEFT_BUFFER - this.drawSegments[i].x;
                if (tempXAdjustment > xAdjustment)
                    xAdjustment = tempXAdjustment;
            }

            if (this.drawSegments[i].x > DrawDisplayData.RIGHT_BUFFER) {//Testing
                tempXAdjustment = this.drawSegments[i].x - DrawDisplayData.RIGHT_BUFFER;
                if (tempXAdjustment > xRightAdjustment)
                    xRightAdjustment = tempXAdjustment;
            }

            if (this.drawSegments[i].y < DrawDisplayData.TOP_BUFFER) {
                tempYAdjustment = DrawDisplayData.TOP_BUFFER - this.drawSegments[i].y;
                if (tempYAdjustment > yAdjustment)
                    yAdjustment = tempYAdjustment;
            }

            if (this.drawSegments[i].y > DrawDisplayData.BOTTOM_BUFFER) {
                tempYAdjustment = this.drawSegments[i].y - DrawDisplayData.BOTTOM_BUFFER;
                if (tempYAdjustment > yAdjustment)
                    yBottomAdjustment = tempYAdjustment;
            }
        }

        for (i = 0; i < this.lastSegments.length; i++) {
            if (this.lastSegments[i].x < DrawDisplayData.LEFT_BUFFER) {
                tempXAdjustment = DrawDisplayData.LEFT_BUFFER - this.lastSegments[i].x;
                if (tempXAdjustment > xAdjustment)
                    xAdjustment = tempXAdjustment;
            }

            if (this.lastSegments[i].x > DrawDisplayData.RIGHT_BUFFER) {//Testing
                tempXAdjustment = this.lastSegments[i].x - DrawDisplayData.RIGHT_BUFFER;
                if (tempXAdjustment > xRightAdjustment)
                    xRightAdjustment = tempXAdjustment;
            }

            if (this.lastSegments[i].y < DrawDisplayData.TOP_BUFFER) {
                tempYAdjustment = DrawDisplayData.TOP_BUFFER - this.lastSegments[i].y;
                if (tempYAdjustment > yAdjustment)
                    yAdjustment = tempYAdjustment;
            }

            if (this.lastSegments[i].y > DrawDisplayData.BOTTOM_BUFFER) {
                tempYAdjustment = this.lastSegments[i].y - DrawDisplayData.BOTTOM_BUFFER;
                if (tempYAdjustment > yAdjustment)
                    yBottomAdjustment = tempYAdjustment;
            }
        }

        for (i = 0; i < this.extSegments.length; i++) {
            if (this.extSegments[i].x < DrawDisplayData.LEFT_BUFFER) {
                tempXAdjustment = DrawDisplayData.LEFT_BUFFER - this.extSegments[i].x;
                if (tempXAdjustment > xAdjustment)
                    xAdjustment = tempXAdjustment;
            }

            if (this.extSegments[i].x > DrawDisplayData.RIGHT_BUFFER) {//testing
                tempXAdjustment = this.extSegments[i].x - DrawDisplayData.RIGHT_BUFFER;
                if (tempXAdjustment > xRightAdjustment)
                    xRightAdjustment = tempXAdjustment;
            }

            if (this.extSegments[i].y < DrawDisplayData.TOP_BUFFER) {
                tempYAdjustment = DrawDisplayData.TOP_BUFFER - this.extSegments[i].y;
                if (tempYAdjustment > yAdjustment)
                    yAdjustment = tempYAdjustment;
            }

            if (this.extSegments[i].y > DrawDisplayData.BOTTOM_BUFFER) {
                tempYAdjustment = this.extSegments[i].y - DrawDisplayData.BOTTOM_BUFFER;
                if (tempYAdjustment > yAdjustment)
                    yBottomAdjustment = tempYAdjustment;
            }
        }
        //END FIND ADJUSTMENTS TO MAKE

        //MAKE THE ADJUSTMENTS
        for (i = 0; i < this.drawSegments.length; i++) {
            if (xAdjustment !== 0)
                this.drawSegments[i].x = this.drawSegments[i].x + xAdjustment;
            if (xRightAdjustment !== 0)
                this.drawSegments[i].x = this.drawSegments[i].x - xRightAdjustment;
            if (yAdjustment !== 0)
                this.drawSegments[i].y = this.drawSegments[i].y + yAdjustment;
            if (yBottomAdjustment !== 0)
                this.drawSegments[i].y = this.drawSegments[i].y - yBottomAdjustment;
        }

        for (i = 0; i < this.extSegments.length; i++) {
            if (xAdjustment !== 0)
                this.extSegments[i].x = this.extSegments[i].x + xAdjustment;
            if (xRightAdjustment !== 0)
                this.extSegments[i].x = this.extSegments[i].x - xRightAdjustment;
            if (yAdjustment !== 0)
                this.extSegments[i].y = this.extSegments[i].y + yAdjustment;
            if (yBottomAdjustment !== 0)
                this.extSegments[i].y = this.extSegments[i].y - yBottomAdjustment;
        }

        for (i = 0; i < this.lastSegments.length; i++) {
            if (xAdjustment !== 0)
                this.lastSegments[i].x = this.lastSegments[i].x + xAdjustment;
            if (xRightAdjustment !== 0)
                this.lastSegments[i].x = this.lastSegments[i].x - xRightAdjustment;
            if (yAdjustment !== 0)
                this.lastSegments[i].y = this.lastSegments[i].y + yAdjustment;
            if (yBottomAdjustment !== 0)
                this.lastSegments[i].y = this.lastSegments[i].y - yBottomAdjustment;
        }
    }

    drawing(event: paper.ToolEvent, bUp: boolean) {  // Main Drawing Function.
        //transform event position to stay within buffer boundaries
        var eventPointY = event.point.y;
        var eventPointX = event.point.x;

        if (eventPointY < DrawDisplayData.TOP_BUFFER)
            eventPointY = DrawDisplayData.TOP_BUFFER;
        else if (eventPointY > DrawDisplayData.BOTTOM_BUFFER)
            eventPointY = DrawDisplayData.BOTTOM_BUFFER;

        if (eventPointX > DrawDisplayData.RIGHT_BUFFER)
            eventPointX = DrawDisplayData.RIGHT_BUFFER;
        else if (eventPointX < DrawDisplayData.LEFT_BUFFER)
            eventPointX = DrawDisplayData.LEFT_BUFFER;
        //end transform event position

        if (this.firstDrag === 0) {
            this.tool.minDistance = 1;
            this.firstDrag = 1;
            // Get the direction of drawing
            if (Math.abs(event.point.x - this.actualStartPoint.x) > Math.abs(event.point.y - this.actualStartPoint.y)) {
                this.rectDirection = 1;  //  Horizontal
                if (eventPointX > this.actualStartPoint.x) {
                    this.extSegments.push(this.startPoint);

                    this.drawSegments.push(new Point(this.startPoint.x, this.startPoint.y - DisplayFunctions.RECTWIDTH));
                    this.leftToRight = 1;
                } else {
                    this.extSegments.push(this.startPoint);

                    this.drawSegments.push(new Point(this.startPoint.x, this.startPoint.y + DisplayFunctions.RECTWIDTH));
                    this.leftToRight = -1;
                }
            } else {
                this.rectDirection = 0;  //  Vertical
                if (eventPointY > this.actualStartPoint.y) {
                    this.extSegments.push(this.startPoint);

                    this.drawSegments.push(new Point(this.startPoint.x + DisplayFunctions.RECTWIDTH, this.startPoint.y));
                    this.topToBottom = 1;
                } else {
                    this.extSegments.push(this.startPoint);

                    this.drawSegments.push(new Point(this.startPoint.x - DisplayFunctions.RECTWIDTH, this.startPoint.y));
                    this.topToBottom = -1;
                }
            }
        }//end first drag

        // the rectangle was already drawed, then remove to redraw it.
        if (this.drawed) {
            this.drawPath.remove();
        }

        var point;
        var size;
        // calculate new point and new size from current mouse point.
        if (this.rectDirection === 0) {//vertical
            if (this.topToBottom === 1) {
                point = new Point(this.startPoint.x, this.startPoint.y);
                size = new Size(DisplayFunctions.RECTWIDTH, eventPointY - this.startPoint.y);
            } else {
                point = new Point(this.startPoint.x - DisplayFunctions.RECTWIDTH, eventPointY);
                size = new Size(DisplayFunctions.RECTWIDTH, this.startPoint.y - eventPointY);
            }
        } else {// horizontal
            if (this.leftToRight === 1) {
                point = new Point(this.startPoint.x, this.startPoint.y - DisplayFunctions.RECTWIDTH);
                size = new Size(eventPointX - this.startPoint.x, DisplayFunctions.RECTWIDTH);
            } else {
                point = new Point(eventPointX, this.startPoint.y);
                size = new Size(this.startPoint.x - eventPointX, DisplayFunctions.RECTWIDTH);
            }
        }

        // Draw rectangle
        this.drawPath = new Path.Rectangle(point, size);
        this.drawPath.style = {
            fillColor: 'green',
            strokeWidth: '0.7'
        };

        if (this.rectDirection === 0) {//vertical
            if (this.topToBottom === 1) {
                this.updateHUD(eventPointY - this.startPoint.y, eventPointX, eventPointY + 70);
            } else {
                this.updateHUD(this.startPoint.y - eventPointY, eventPointX - 110, eventPointY - 10);
            }
        } else {// horizontal
            if (this.leftToRight === 1) {
                this.updateHUD(eventPointX - this.startPoint.x, eventPointX, eventPointY);
            } else {
                this.updateHUD(this.startPoint.x - eventPointX, eventPointX, eventPointY);
            }
        }

        this.drawed = true;  // set to true because rectangle was drawed.

        if (bUp) {  // It presents that the mouse up event was called. because drawing was completed, complete calculating segments
            if (this.rectDirection === 0) {
                if (this.topToBottom === 1) {
                    this.lastSegments.push(new Point(this.startPoint.x + DisplayFunctions.RECTWIDTH, eventPointY));
                    this.lastSegments.push(new Point(this.startPoint.x, eventPointY));
                } else {
                    this.lastSegments.push(new Point(this.startPoint.x - DisplayFunctions.RECTWIDTH, eventPointY));
                    this.lastSegments.push(new Point(this.startPoint.x, eventPointY));
                }
            } else {
                if (this.leftToRight === 1) {
                    this.lastSegments.push(new Point(eventPointX, this.startPoint.y - DisplayFunctions.RECTWIDTH));
                    this.lastSegments.push(new Point(eventPointX, this.startPoint.y));
                } else {
                    this.lastSegments.push(new Point(eventPointX, this.startPoint.y + DisplayFunctions.RECTWIDTH));
                    this.lastSegments.push(new Point(eventPointX, this.startPoint.y));
                }
            }

            //fix any boundary issues for each segment being drawn currently
            this.adjustSegmentsForBuffer();
            this.dashedItems.push(this.drawPath);
            //reset hud to zero
            this.updateHUD(0, eventPointX, eventPointY);
        }

        // It is part to decide whether the drawing direction have to be changed or not.
        if (this.rectDirection === 0) { //  Vertical To Horizontal

            if (this.topToBottom === 1) {
                if ((this.startPoint.x - DisplayFunctions.RECTWIDTH / 2 > eventPointX) || (this.startPoint.x + DisplayFunctions.RECTWIDTH < eventPointX)) {//Determines if user has dragged far enough before changing direction
                    if (this.startPoint.x - DisplayFunctions.RECTWIDTH / 2 > eventPointX) {
                        this.changeDirection(1);
                        this.startPoint = new Point(this.startPoint.x + DisplayFunctions.RECTWIDTH, eventPointY);
                        this.leftToRight = -1;

                        this.drawSegments.push(new Point(this.startPoint.x, this.startPoint.y + DisplayFunctions.RECTWIDTH));
                        this.extSegments.push(new Point(this.startPoint.x - DisplayFunctions.RECTWIDTH, this.startPoint.y));
                        this.angleSegments.push(new Point(this.startPoint.x - DisplayFunctions.RECTWIDTH / 2, this.startPoint.y + DisplayFunctions.RECTWIDTH / 2));

                    } else {
                        this.changeDirection(1);
                        this.startPoint = new Point(this.startPoint.x, eventPointY);
                        this.leftToRight = 1;

                        this.drawSegments.push(new Point(this.startPoint.x + DisplayFunctions.RECTWIDTH, this.startPoint.y - DisplayFunctions.RECTWIDTH));
                        this.extSegments.push(new Point(this.startPoint.x, this.startPoint.y));
                        this.angleSegments.push(new Point(this.startPoint.x + DisplayFunctions.RECTWIDTH / 2, this.startPoint.y - DisplayFunctions.RECTWIDTH / 2));

                    }
                }
            } else {
                if ((this.startPoint.x + DisplayFunctions.RECTWIDTH / 2 < eventPointX) || (this.startPoint.x - DisplayFunctions.RECTWIDTH > eventPointX)) {
                    if (this.startPoint.x + DisplayFunctions.RECTWIDTH / 2 < eventPointX) {
                        this.changeDirection(1);
                        this.startPoint = new Point(this.startPoint.x - DisplayFunctions.RECTWIDTH, eventPointY);
                        this.leftToRight = 1;

                        this.drawSegments.push(new Point(this.startPoint.x, this.startPoint.y - DisplayFunctions.RECTWIDTH));
                        this.extSegments.push(new Point(this.startPoint.x + DisplayFunctions.RECTWIDTH, this.startPoint.y));
                        this.angleSegments.push(new Point(this.startPoint.x + DisplayFunctions.RECTWIDTH / 2, this.startPoint.y - DisplayFunctions.RECTWIDTH / 2));

                    } else {
                        this.changeDirection(1);
                        this.startPoint = new Point(this.startPoint.x, eventPointY);
                        this.leftToRight = -1;

                        this.drawSegments.push(new Point(this.startPoint.x - DisplayFunctions.RECTWIDTH, this.startPoint.y + DisplayFunctions.RECTWIDTH));
                        this.extSegments.push(new Point(this.startPoint.x, this.startPoint.y));
                        this.angleSegments.push(new Point(this.startPoint.x - DisplayFunctions.RECTWIDTH / 2, this.startPoint.y + DisplayFunctions.RECTWIDTH / 2));

                    }

                }
            }

        } else {   //   Horizontal To Vertical
            if (this.leftToRight === 1) {
                if ((this.startPoint.y + DisplayFunctions.RECTWIDTH / 2 < eventPointY) || (this.startPoint.y - DisplayFunctions.RECTWIDTH > eventPointY)) {

                    if (this.startPoint.y + DisplayFunctions.RECTWIDTH / 2 < eventPointY) {
                        this.changeDirection(0);
                        this.startPoint = new Point(eventPointX, this.startPoint.y - DisplayFunctions.RECTWIDTH);
                        this.topToBottom = 1;

                        this.drawSegments.push(new Point(this.startPoint.x + DisplayFunctions.RECTWIDTH, this.startPoint.y));
                        this.extSegments.push(new Point(this.startPoint.x, this.startPoint.y + DisplayFunctions.RECTWIDTH));
                        this.angleSegments.push(new Point(this.startPoint.x + DisplayFunctions.RECTWIDTH / 2, this.startPoint.y + DisplayFunctions.RECTWIDTH / 2));

                    } else {
                        this.changeDirection(0);
                        this.startPoint = new Point(eventPointX, this.startPoint.y);
                        this.topToBottom = -1;

                        this.drawSegments.push(new Point(this.startPoint.x - DisplayFunctions.RECTWIDTH, this.startPoint.y - DisplayFunctions.RECTWIDTH));
                        this.extSegments.push(new Point(this.startPoint.x, this.startPoint.y));
                        this.angleSegments.push(new Point(this.startPoint.x - DisplayFunctions.RECTWIDTH / 2, this.startPoint.y - DisplayFunctions.RECTWIDTH / 2));
                    }
                }
            } else {
                if ((this.startPoint.y - DisplayFunctions.RECTWIDTH / 2 > eventPointY) || (this.startPoint.y + DisplayFunctions.RECTWIDTH < eventPointY)) {
                    if (this.startPoint.y - DisplayFunctions.RECTWIDTH / 2 > eventPointY) {
                        this.changeDirection(0);
                        this.startPoint = new Point(eventPointX, this.startPoint.y + DisplayFunctions.RECTWIDTH);
                        this.topToBottom = -1;

                        this.drawSegments.push(new Point(this.startPoint.x - DisplayFunctions.RECTWIDTH, this.startPoint.y));
                        this.extSegments.push(new Point(this.startPoint.x, this.startPoint.y - DisplayFunctions.RECTWIDTH));
                        this.angleSegments.push(new Point(this.startPoint.x - DisplayFunctions.RECTWIDTH / 2, this.startPoint.y - DisplayFunctions.RECTWIDTH / 2));

                    } else {
                        this.changeDirection(0);
                        this.startPoint = new Point(eventPointX, this.startPoint.y);
                        this.topToBottom = 1;

                        this.drawSegments.push(new Point(this.startPoint.x + DisplayFunctions.RECTWIDTH, this.startPoint.y + DisplayFunctions.RECTWIDTH));
                        this.extSegments.push(new Point(this.startPoint.x, this.startPoint.y));
                        this.angleSegments.push(new Point(this.startPoint.x + DisplayFunctions.RECTWIDTH / 2, this.startPoint.y + DisplayFunctions.RECTWIDTH / 2));
                    }
                }
            }
        }
    }

    changeDirection(direct: any) {  // It is called when the user change drawing direction. Vertical To Horizontal or Horizontal To Vertical
        this.rectDirection = direct;
        this.drawed = false;
        this.dashedItems.push(this.drawPath);
    }

    updateHUD(pixelLength: any, eventPointX: any, eventPointY: any) {
        this.hud.content = 'Length (in.): ' + DisplayFunctions.RoundPixelToInch(pixelLength).toString();
        this.hud.point = new Point(new Point(eventPointX + 20, eventPointY - 20));
        this.hud.bringToFront();
    }

    //04/04/2017: Liem Bui update for [Sage-654] When a user in EE tries to move past adding an edge, and the message pops up warning them, please make any countertops WITHOUT an edge selection glow a translucent flashing red to show which top is missing the edge.
    makePathFromSegments(segments: any) { // It is function to make completed path from segments.
        this.completedPath = new Path(segments);
        this.completedPath.strokeColor = 'black';

        var invalid = false;

        if (this.edgeInvalidObjs.length > 0) {
            for (let i = 0; i < this.edgeInvalidObjs.length; i++) {
                if (segments[0].point
                    && segments[0].point.x === this.edgeInvalidObjs[i].segments[0].point.x
                    && segments[0].point.y === this.edgeInvalidObjs[i].segments[0].point.y) {
                    invalid = true;
                    break;
                }
            }
        }

        if (invalid)
            this.completedPath.style = DrawDisplayData.INVALID_EDGE_STROKESTYLE;
        else
            this.completedPath.style = DrawDisplayData.STROKESTYLE;

        this.completedPath.closed = true;
        for (let i = 0; i < this.completedPath.segments.length; i++) {
            this.completedPath.segments[i].data = {};
        }
        this.completedPath.data = {};
        return this.completedPath;
    }

    endDraw(event: paper.ToolEvent): boolean {
        this.hud.visible = false;
        this.bDrawing = false;
        this.drawing(event, true);
        this.drawed = false;
        for (var i = 0, l = this.dashedItems.length; i < l; i++) {   // Remove temporary rectangles.
            var item = this.dashedItems[i];
            item.remove();
        }
        return this.pathCompletion();
    }

    pathCompletion(): boolean { // It is function to make completed path from segments.

        if (this.drawSegments.length === 1) {
            if ((Math.abs(this.drawSegments[0].x - this.lastSegments[0].x) < DisplayFunctions.RECTWIDTH) && (Math.abs(this.drawSegments[0].y - this.lastSegments[0].y) < DisplayFunctions.RECTWIDTH))
                return false;
        }

        var newSegments = this.drawSegments.concat(this.lastSegments).concat(this.extSegments.reverse());
        this.completedPath = this.makePathFromSegments(newSegments);
        //checkSidesForConsistency(completedPath);
        return true;
    }

    //04/04/2017: Liem Bui update for [Sage-654] When a user in EE tries to move past adding an edge, and the message pops up warning them, please make any countertops WITHOUT an edge selection glow a translucent flashing red to show which top is missing the edge.
    reSetEdgeInvalidObjs(drawDataObj: DrawData) {
        this.edgeInvalidObjs = [];
        for (var i = 0; i < drawDataObj.CounterTopArr.length; i++) {
            var path = drawDataObj.CounterTopArr[i].path;
            var ec = drawDataObj.getEdgeColorFromPath(path);
            var edgeDataObj;

            if (ec && ec.ec.e1 && !(ec.ec.e1 === 'none')) {
                var isEdge = false;
                for (var j = 0; j < path.segments.length; j++) {
                    var anySegment = <any>path.segments[j];
                    // TODO: remove any casting
                    edgeDataObj = anySegment.data.edgeData;
                    if (edgeDataObj) {
                        isEdge = true;
                        break;
                    }
                }

                // Get list edges missing
                if (!isEdge) {
                    this.edgeInvalidObjs.push(path);
                }
            }
        }
        if (this.edgeInvalidObjs.length === 0)
            this.isEdgeInvalid = false;
    }

}
